import { Alarm, ExtensionApiFactory, IExtensionApiStrategy } from '~cdw-ae/common/frontend/browser-extension-api';

import { setLastUpated } from './alarm.state';

import { rootStore } from '../extension-store/extension.store';
import UtilsService from '../utils/utils.service';

const MAIN_ALARM_NAME = 'gopher-buddy-main-alarm';
let extensionApi: IExtensionApiStrategy;

const AlertService = {
  init: async (): Promise<void> => {
    UtilsService.debugLog('Main Alarm Init');
    extensionApi = ExtensionApiFactory();
    await extensionApi.clearAllAlarms();
    const alarm: Alarm = await extensionApi.getAlarm(MAIN_ALARM_NAME);
    if (typeof alarm === 'undefined') {
      UtilsService.debugLog(`Creating main alarm: ${MAIN_ALARM_NAME}`);
      await extensionApi.createAlarm(MAIN_ALARM_NAME, {
        periodInMinutes: 1,
      });
    } else {
      UtilsService.debugLog(`Creating main alarm: ${MAIN_ALARM_NAME}. ${JSON.stringify(alarm)}`);
    }

    extensionApi.addAlarmListener((alarmtrigger: Alarm) => {
      if (alarmtrigger.name === MAIN_ALARM_NAME) {
        UtilsService.debugLog(`Main alarm triggered: ${MAIN_ALARM_NAME}`, `Saving State`);
        rootStore.dispatch(setLastUpated(Date.now()));
      }
    });
  },
};

export default AlertService;
